import { render, staticRenderFns } from "./diaryManage.vue?vue&type=template&id=baf380aa&scoped=true"
import script from "./diaryManage.vue?vue&type=script&lang=js"
export * from "./diaryManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf380aa",
  null
  
)

export default component.exports